import {FiTrash} from "react-icons/fi";

import {ButtonWithMutationAndConfirmationDialog} from "@/components/ButtonWithMutationAndConfirmationDialog/ButtonWithMutationAndConfirmationDialog.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {
  GQL_BULK_DELETE_INCIDENTS,
  GQL_INCIDENTS,
  GQL_INCIDENTS_COUNTS,
  GQL_STATUS_PAGE_QUERY,
  GQL_STATUSPAGE_INCIDENTS,
} from "@/lib/queries/statuspages.ts";

export interface BulkDeleteIncidentsActionButtonWithConfirmationProps {
  selectedItemsIds: number[];
  onSuccess?: () => void;
}

export const BulkDeleteIncidentsActionButtonWithConfirmation = ({
  selectedItemsIds,
  onSuccess,
}: BulkDeleteIncidentsActionButtonWithConfirmationProps) => {
  return (
    <ButtonWithMutationAndConfirmationDialog
      dialogTitle="Confirm Bulk Incidents Delete"
      tooltip={"Delete Incidents"}
      dialogElement={<p>Are you sure you want to delete the selected Incidents?</p>}
      mutation_variables={{
        incidentIds: selectedItemsIds,
      }}
      mutation_hook_options={{
        refetchQueries: [GQL_STATUS_PAGE_QUERY, GQL_STATUSPAGE_INCIDENTS, GQL_INCIDENTS_COUNTS, GQL_INCIDENTS],
      }}
      mutation_GQL={GQL_BULK_DELETE_INCIDENTS}
      postMutationAction={onSuccess}
      variant={"tableCrown"}
    >
      <Icon icon={FiTrash} />
      <span>Delete</span>
    </ButtonWithMutationAndConfirmationDialog>
  );
};
